import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  avatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    objectFit: "cover"
  },
  text: {
    color: "white",
  },
}));
